export function showSpinner(state) {
  return state.pendingFetches > 0 && !state.hasFetched;
}
